import React, { FC, memo, useMemo } from 'react';
// Import Components
import { DynamicRowList } from 'components';
// Import Services
import { Helpers } from 'services';
// Import Constants
import { RecurrenceDataColumnsConfig } from 'constants/common';
// Import Types
import type { RecurrenceListProps } from './types';
import { Row } from '../DynamicRowList/types';

const { formatRecurrenceDates } = Helpers;

const RecurrenceList: FC<RecurrenceListProps> = ({ upcomingExecutions = [] }) => {
    const recurrenceRowsData = useMemo<Row[]>(() => formatRecurrenceDates(upcomingExecutions), [upcomingExecutions]);

    return <DynamicRowList columnsConfig={RecurrenceDataColumnsConfig} rows={recurrenceRowsData} />;
};

export default memo(RecurrenceList);
